var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.652 7.525.074.002 1.871.267a.47.47 0 0 1 .403.479A7.93 7.93 0 0 1 8.034 16a7.935 7.935 0 0 1-4.097-1.132l-.989.988a.47.47 0 0 1-.796-.265l-.662-4.64a.47.47 0 0 1 .53-.531l4.64.663a.47.47 0 0 1 .266.796l-.901.9a5.163 5.163 0 0 0 2.01.409A5.162 5.162 0 0 0 13.19 8.03c0-.328.294-.535.536-.504ZM7.967 0c1.449 0 2.858.394 4.1 1.143l.965-.965a.47.47 0 0 1 .796.265l.663 4.64a.47.47 0 0 1-.53.53L9.32 4.952a.47.47 0 0 1-.265-.796l.93-.93A5.158 5.158 0 0 0 2.81 8.04a.47.47 0 0 1-.534.47L.403 8.242A.47.47 0 0 1 0 7.766 7.922 7.922 0 0 1 7.967 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshColored);
export default ForwardRef;